export const FILE_DROPPED = "dragdrop.fileDropped";
export const FILE_VALIDATED = "dragdrop.fileValidated";
export const CSV_UPLOADED = "data.csvUploaded";
export const NOTIFY = "system.notify";

